import { SdmSpacer, SdmTypography } from 'components';
import React from 'react';
import { theme } from 'theme';

const LabelContainer = ({
  label,
  isRequired = false,
  description,
  hideSpacer = false,
}) => (
  <>
    {label && (
      <>
        {!hideSpacer && <SdmSpacer height={10} />}
        <SdmTypography
          variant={'h5'}
          style={{ margin: 0, textTransform: 'uppercase' }}
        >
          {label}{' '}
          {isRequired ? (
            <span
              style={{
                color: theme.colors.primary.red,
                fontWeight: 400,
              }}
            >
              {' '}
              *
            </span>
          ) : null}
        </SdmTypography>
      </>
    )}
    {description && (
      <SdmTypography variant={'h5Regular'} style={{ margin: 0 }}>
        {description}
      </SdmTypography>
    )}
  </>
);

export default LabelContainer;
